module.exports = __webpack_public_path__ + "img/399.3f1cce0d.png";